import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SnackbarService } from '@bcl/design-system';
import { MenuController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { BackButtonService } from 'src/app/services/back-button.service';
import { ChatListComponent } from 'src/app/shared-components/components/chat-list/chat-list.component';

@Component({
  selector: 'app-chats',
  templateUrl: './chats.component.html',
  styleUrls: ['./chats.component.scss'],
})
export class ChatsPage implements OnDestroy, OnInit {
  @ViewChild(ChatListComponent) chatListComponent: ChatListComponent;

  public loading = false;
  private destroyed$ = new Subject<void>();

  constructor(
    private snackbarService: SnackbarService,
    private menuCtrl: MenuController,
    private backButtonService: BackButtonService
  ) {}

  public ngOnInit(): void {
    this.backButtonService.hideBackButton();
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ionViewWillEnter() {
    this.menuCtrl.close();
    this.backButtonService.hideBackButton();

    if (this.chatListComponent) {
      this.chatListComponent.reloadChats();
    }
  }
}
